export const SET_MODAL_SELECT_PAIR = 'SET_MODAL_SELECT_PAIR';
export const SET_MODAL_TERMS = 'SET_MODAL_TERMS';
export const SET_MODAL_CONFIRM_ADJUST_LEVERAGE = 'SET_MODAL_CONFIRM_ADJUST_LEVERAGE';
export const SET_MODAL_LEVERAGE_OPEN = 'SET_MODAL_LEVERAGE_OPEN';
